export function applySelection(obj) {
  const { selection } = obj;
  const objective = {
    percent: selection.metrics.percent,
    years: selection.metrics.duration,
  };

  return {
    selection: selection.name,
    objective,
    assets: selection.assets,
    diversified: {
      diversified: 'no',
      assets: [],
    },
  };
}

export default {
  applySelection,
};
